@if (serviceCategories?.length) {
  <div class="accordion mt-2" id="pre-defined-slot-services-accordion" role="region" aria-label="Service selection">

    @if (partner.enable_services_search === 1) {
      <div class="row mt-2 mb-2">
        <div class="col-lg-12">
          <input
            [(ngModel)]="searchServiceQuery"
            name="searchServiceQuery"
            id="pdsSearchServiceQuery"
            type="text"
            aria-label="Search Service"
            class="form-control cbw-input-field"
            [placeholder]="'appointments.step1.search_services_helper_text' | translate"
            (ngModelChange)="onSearchServiceQueryChanged()"
          />
        </div>
      </div>
    }

    <ngb-accordion #accordion="ngbAccordion" [activeIds]="activePanels">
      @for (group of filteredServiceCategories; track group.category.id; let i = $index) {
        <ngb-panel cardClass="calio-custom-accordion" id="static-{{ i }}">
          <ng-template ngbPanelHeader let-opened="opened">
            <div
              class="d-flex align-items-center justify-content-between custom-accordion-header"
              (click)="accordion.toggle('static-' + i)"
              (keydown.enter)="accordion.toggle('static-' + i)"
              (keydown.space)="accordion.toggle('static-' + i); $event.preventDefault()"
              role="tab"
              tabindex="0"
              [attr.aria-expanded]="opened"
              [attr.aria-controls]="'service-panel-' + i"
              [attr.aria-label]="(group.category | translation: 'name': lang) + ' - Expand/Collapse'"
            >
              <div class="pe-3">
                <app-cw-multi-lang-title [isWordBreakEnabled]="false" [item]="group.category" lang="{{ lang }}" />
              </div>
              <div>
                <fa-icon class="icon" [icon]="opened ? 'chevron-up' : 'chevron-down'" aria-hidden="true" />
              </div>
            </div>
          </ng-template>

          <ng-template ngbPanelContent>
            <div id="service-panel-{{ i }}" role="region" [attr.aria-labelledby]="'static-' + i">
              <div class="service-group">
                @for (service of group.services; track service.id) {
                  <div
                    class="accordion-row d-flex align-items-center"
                    [ngClass]="{ 'selected-service-row': selectedService?.id === service.id }"
                    role="group"
                    [attr.aria-labelledby]="'pds-service-' + service.id"
                  >
                    <app-cw-checkbox-radio-button
                      class="w-100"
                      [customId]="service.id"
                      name="preDefinedSlotServices"
                      [value]="service.name"
                      [checked]="selectedService?.id === service.id"
                      [isCheckbox]="false"
                      labelClass="w-100 justify-content-between"
                      (selectionChange)="onSelectService(service)"
                    >
                      <div class="service-title pe-3" id="pds-service-{{ service.id }}">
                        <div class="words-break">
                          <app-cw-multi-lang-title
                            titleClass="cw-custom-title"
                            badgeLabel="{{ 'internal_label' | translate }}"
                            [item]="service"
                            [lang]="lang"
                            [showBadge]="service.is_internal === 1"
                          />
                        </div>
                        @if (partner.show_inline_description === 1) {
                          @if (service.description && service.description.trim() !== '' && service.description !== 'null' && service.description !== null) {
                            <div class="cbw-service-description pe-2">
                              {{ service | translation: 'description': lang }}
                            </div>
                          }
                        }
                      </div>
                      <div class="cbw-service-duration" aria-label="Service duration">
                        <span>
                          @if ((service.duration | replaceComma | toHour) > 0) {
                            <span>
                              {{ service.duration | replaceComma | toHour }}{{ 'common.durationHour' | translate }}
                            </span>
                          }
                          @if ((service.duration | replaceComma | toMinute) > 0) {
                            <span>
                              {{ service.duration | replaceComma | toMinute }}{{ 'common.durationMinute' | translate }}
                            </span>
                          }
                        </span>
                      </div>
                      <div class="cbw-service-price">
                        @if (service.price > 0) {
                          <div>
                            <span class="cbw-service-price">
                              @if (service.is_price_from_activated) {
                                <span>{{ 'common.price_from_label' | translate }}</span>
                              }
                              {{ service.price | calioCurrency: partner?.currency: lang }}
                            </span>
                          </div>
                          @if (service.tax && service.tax.rate >= 0) {
                            <div class="cbw-taxes" aria-label="Tax info">
                              ({{ 'tax_info.' + vatTypeLabelKey(partner.widget_vat_type) | translate }}
                              @if (vatTypeLabelKey(partner.widget_vat_type) !== 'exclude') {
                                <span class="cbw-taxes-percentage">{{ service.tax.rate }}%</span>
                              }
                              {{ 'tax_info.taxes' | translate }})
                            </div>
                          }
                        }
                        @if (service.price === 0) {
                          <span aria-label="Free service">{{ 'free' | translate }}</span>
                        }
                      </div>
                      @if (partner.show_inline_description === 0 && service.description && service.description.trim() !== '' && service.description !== 'null' && service.description !== null) {
                        <div class="cbw-service-desc">
                          @if (service.is_multi_language === 1) {
                            <app-cw-question-mark [id]="service.id" [description]="service | translation: 'description': lang" />
                          }
                          @if (service.is_multi_language === 0) {
                            <app-cw-question-mark [id]="service.id" [description]="service.description" />
                          }
                        </div>
                      }
                    </app-cw-checkbox-radio-button>

                    @if (showShortcutButton && selectedService?.id === service.id) {
                      <div class="cbw-service-shortcut-next-button">
                        <div
                          class="next-arrow-container"
                          (click)="shortcutNavigateToSlots.emit()"
                          (keydown.enter)="shortcutNavigateToSlots.emit()"
                          (keydown.space)="shortcutNavigateToSlots.emit(); $event.preventDefault()"
                          role="button"
                          tabindex="0"
                          attr.aria-label="{{ 'buttons.next' | translate }}"
                        >
                          <span>
                            <fa-icon class="icon cbw-next-arrow-button d-flex" icon="chevron-circle-right" aria-hidden="true" />
                          </span>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </ng-template>
        </ngb-panel>
      }
    </ngb-accordion>
  </div>
} @else {
  <app-new-alert
    title="{{ 'pre_defined_slots.no_services_available' | translate }}"
    type="warning"
    customClass="mt-3 mb-3"
  />
}
